import React from 'react';
import './loginMessage.css';

const LoginMessage = props => {
    // console.log(props);
    if(props.setLoginMessage !== '') {
        return (props.setLoginMessage.includes('Successfully') ? 
            <div className='success'>{props.setLoginMessage}</div> : <div className='failed'>{props.setLoginMessage}</div>
        );
    } else if(props.setLoginMessage === '') {
        return (<div className='empty'></div>);
    } else {
        return (
            <div className='failed'>ERROR something went wrong when logging in, please try again later</div>
        );
    }
}

export default LoginMessage;